import React from 'react';

const Loading = (props) => {
    if(props.loading) {
        return (
            <div style={_.content}>
                <i className="fa fa-circle-o-notch fa-spin" style={_.spin}></i>
            </div>
        );
    }
    return <></>
}

const _ = {
    content: {
        position: 'fixed',
        zIndex: 9999,
        left: 0,
        top: 0,
        width: '100%',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    spin: {
        fontSize: '5rem',
        color: '#FFFFFF'
    }
}

export default Loading;